import Image from "next/image";
import { Fragment, useState } from "react";
import ExpandableBox from "../../../components/koach/Faqs/components/ExpandableBox";
import CarouselItemDesktop from "./components/CarouselItemDesktop";
import MobileSelector from "./components/MobileSelector";
import { faqItems, generateCarouselData } from "./utils";

const FaqMainPage = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const carouselData = generateCarouselData() || [];
  const [isOpened, setSelectOpened] = useState(false);

  const clickHandler = (idx: number) => {
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };
  const onClick = () => {
    setSelectOpened(!isOpened);
  };

  return (
    <div className="relative px-5 mt-10 mb-10 xl:mb-14 xl:mt-20">
      <div className="flex flex-col relative lg:flex-row md:px-6 px-5 lg:px-11 xl:px-20">
        <div className="hidden lg:flex flex-row lg:flex-col w-full lg:w-1/5 mx-auto sticky top-0 lg:top-2 h-max z-40 bg-white p-5 lg:p-0 text-center mt-4">
          {carouselData.map(({ header }, idx) => (
            <CarouselItemDesktop key={idx} title={header} index={idx} />
          ))}
        </div>
        <div className="flex lg:hidden sticky top-0 z-40 py-5 bg-white">
          <div
            className="text-magenta border rounded px-5 py-2 w-full flex justify-between font-bold"
            onClick={onClick}
          >
            Select FAQ
            <Image
              src="/chevron-down-pink.svg"
              width={11}
              height={6}
              alt="chevron"
              className={`transition-all duration-300 ease-in-out ${
                isOpened === true ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
          <div
            onClick={onClick}
            className={` ${
              isOpened ? "block" : "hidden"
            } absolute z-50 w-full mt-8 pt-2 bg-white border border-t-0 text-magenta`}
          >
            {carouselData.map(({ header, link }, idx) => (
              <Fragment key={idx}>
                <MobileSelector header={header} link={link} idx={idx} />
              </Fragment>
            ))}
          </div>
        </div>
        <div className="flex flex-col  w-full lg:w-4/5 mx-auto">
          <div id="1">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">
              Learn about Klink
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Learn about Klink";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div id="2">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">
              Signing up to Klink
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Signing up to Klink";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div id="3">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">
              Linking bank accounts
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Linking bank accounts";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div id="4">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">
              Spending Insights & Spendometer
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Spending Insights & Spendometer";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div id="5">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">
              Mortgage Readiness Score
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Mortgage Readiness Score";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div id="6">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">
              Quizzes & Rewards
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Quizzes & Rewards";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div id="7">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">
              Knowledge & Learning
            </h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Knowledge & Learning";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          <div id="8">
            <h2 className="mb-6 text-xl font-bold mt-20 md:mt-7">Other FAQs</h2>
            <div className="relative z-30 w-full">
              {faqItems
                .filter(function (obj) {
                  return obj.category === "Other FAQs";
                })
                .sort((a, b) => a.index - b.index)
                .map((faq) => (
                  <div key={faq.index}>
                    <ExpandableBox
                      question={faq.question}
                      answer={faq.answer}
                      active={activeIndex === faq.index}
                      clickHandler={() => clickHandler(faq.index)}
                      showOnlyBottomBorder={faq.index === faqItems.length - 1}
                    />
                    {faq.index === faqItems.length - 1 && (
                      <div className="hidden w-1 bg-white h-11 md:inline-block xl:hidden"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqMainPage;
